import { Switch, Route, Redirect } from 'react-router-dom';
import { List } from 'site/atdw/list/list';
import { Edit } from 'site/atdw/edit/edit';
import { MemberList } from 'site/member/list/view';
import { MemberEdit } from 'site/member/edit/view';
import { SearchAtdw } from 'site/atdw/searchAtdw/searchAtdw';
import { FilterEdit } from 'site/filter/edit/view';
import React,{useEffect, useState} from 'react';
import { AppHeader } from 'layout/appHeader';
import { AppSideBar } from 'layout/appSideBar';
import { useAuth } from 'auth';
import { Loading } from 'components';
import env from 'env';
import { getIdToken } from 'lib/auth/services/authHelper';

export function DashboardLayoutV2(props) {

    const _auth = useAuth();
    const [pageLoading, setPageLoading] = useState(true);
    const [pageLoading2, setPageLoading2] = useState(true);
    const [checkAuthSession, setCheckAuthSession] = useState(0);

    useEffect(() =>{
        // if(_auth.session && !_auth.session.expired()){
        //     setPageLoading2(false);
        //     return;
        // }
        setTimeout(() => {
          setPageLoading2(false);
        }, 3000);
    }, []);
    
    useEffect(()=>{
        if(pageLoading2){
          return;
        }
        
        if(_auth.loggedIn()){
            const fetchData = async () => {
                const _token = await getIdToken();
                const res = await fetch(env.apiBase + '/api/atdwadmin/checkadmin', {
                    method : 'get',
                    headers: { 'Authorization': `Bearer ${_token}` }
                });
                const data = await res.json();
                if(data.error){
                    setCheckAuthSession(100);
                }
                setPageLoading(false);
            }
            fetchData();
        }
        else{
          setCheckAuthSession(100);
          setPageLoading(false);
        }
        //setPageLoading(false);

        // eslint-disable-next-line
    }, [_auth.session, pageLoading2] );

    return(
        <div className="app-container app-theme-white fixed-header fixed-sidebar fixed-footer">
            <AppHeader /> 
            {
                pageLoading ? <Loading></Loading> : (
                    checkAuthSession === 100 ? <Redirect to="/admin/login">
                        { _auth.signout() }
                    </Redirect> :
                    <div className="appMain">
                        <AppSideBar />
                        <div className="appMain__outer">
                            <div className="appMain__inner">
                                <Switch>
                                    <Route path="/admin/atdw/search">
                                        <SearchAtdw _autSession = {_auth.session}></SearchAtdw>
                                    </Route>
                                    <Route path="/admin/atdw/list">
                                        <List _autSession = {_auth.session}></List>
                                    </Route>
                                    <Route path="/admin/atdw/edit/:id">
                                        <Edit _autSession = {_auth.session}></Edit>
                                    </Route>
                                    <Route path="/admin/member/edit/:id">
                                        <MemberEdit _autSession = {_auth.session}></MemberEdit>
                                    </Route>
                                    <Route path="/admin/member/list">
                                        <MemberList _autSession = {_auth.session}></MemberList>
                                    </Route>
                                    <Route path="/admin/filter/edit">
                                        <FilterEdit _autSession = {_auth.session}></FilterEdit>
                                    </Route>
                                    <Route path="/*">
                                        <Redirect to="/admin/atdw/list" />
                                    </Route>
                                </Switch>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    )
}